import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router';
import { showDeleteConfirmBox } from '../../../../../components/DeleteConfirmBox';
import { CommonContext, ProgressContext } from '../../../../../contexts';
import { createDiscipleType, deleteDiscipleType, getDiscipleTypes, updateDiscipleType } from '../apis/disciple-apis';
import { DiscipleType } from '../types/disciple';
import styles from './AdminYCMS.module.css';

const AdminYCMS = () => {
  const { categories } = useContext(CommonContext);
  const { spinner } = useContext(ProgressContext);
  const { pathname } = useLocation();

  const [types, setTypes] = useState<DiscipleType[]>([]);
  const [newType, setNewType] = useState<DiscipleType>({ id: 0, department: '', displayName: '', description: '' });

  useEffect(() => {
    getDiscipleTypes().then(setTypes);
  }, []);

  /**
   * 등록
   */
  const handleAddType = async () => {
    try {
      spinner.start();
      const result = await createDiscipleType({ department: newType.department, displayName: newType.displayName, description: newType.description });
      if (!result) {
        throw new Error('등록에 실패했습니다.');
      }
      setTypes([...types, result]);
      setNewType({ id: 0, department: '', displayName: '', description: '' });
      toast.success('등록되었습니다.');
    } catch (error) {
      console.error(error);
      toast.error(error.message || '등록에 실패했습니다.');
    } finally {
      spinner.stop();
    }
  };

  /**
   * 수정
   */
  const handleEdit = async (type: DiscipleType) => {
    try {
      spinner.start();

      // DB에 저장
      const result = await updateDiscipleType(type);

      if (!result) {
        throw new Error('수정에 실패했습니다.');
      }

      // 화면에 표시
      setTypes(types.map((t) => (t.id === type.id ? result : t)));

      toast.success('수정되었습니다.');
    } catch (error) {
      console.error(error);
      toast.error(error.message || '수정에 실패했습니다.');
    } finally {
      spinner.stop();
    }
  };

  /**
   * 삭제
   */
  const handleDelete = async (id: number) => {
    try {
      spinner.start();

      // DB에서 삭제
      await deleteDiscipleType(id);

      // 화면에 표시
      setTypes(types.filter((t) => t.id !== id));

      toast.success('삭제되었습니다.');
    } catch (error) {
      console.error(error);
      toast.error(error.message || '삭제에 실패했습니다.');
    } finally {
      spinner.stop();
    }
  };

  /**
   * Input의 값을 변경한다.
   */
  const handleChange = ({ target: { name, value } }, idx) => {
    const updatedTypes = [...types];
    updatedTypes[idx] = { ...updatedTypes[idx], [name]: value };
    setTypes(updatedTypes);
  };

  return (
    <div id="primary" className="content-area">
      {/* <!--s:#content --> */}
      <div id="content" className="site-content">
        <div>
          <div className="title-inner">
            <img src="/common/images/title.png" alt="" />
            <h1>{categories.find((category) => category.categoryCode === pathname.split('/')[4])?.categoryName}</h1>
          </div>
          <div style={{ height: 20 }}></div>
          <div style={{ clear: 'both' }}></div>
          <div className="title_subpage_solid_1"></div>
          <div style={{ height: 30 }}></div>

          <div className="">
            <table className="tbl_basic">
              <colgroup>
                <col style={{ width: 70 }} />
                <col style={{ width: 140 }} />
                <col style={{ width: 180 }} />
                <col style={{ width: 240 }} />
                <col style={{ width: 140 }} />
              </colgroup>
              <thead>
                <tr>
                  <th>NO.</th>
                  <th>부서</th>
                  <th>제자명</th>
                  <th>설명</th>
                  <th>-</th>
                </tr>
              </thead>
              <tbody>
                {types &&
                  types.map((item, idx) => (
                    <tr key={idx} id={String(idx)}>
                      <td className={styles.td_disciple}>{idx + 1}</td>
                      <td className={styles.td_disciple}>
                        <input type="text" className={styles.textInput} name="department" value={item.department || ''} onChange={(e) => handleChange(e, idx)} />
                      </td>
                      <td className={styles.td_disciple}>
                        <input type="text" className={styles.textInput} name="displayName" value={item.displayName || ''} onChange={(e) => handleChange(e, idx)} />
                      </td>
                      <td className={styles.td_disciple}>
                        <input type="text" className={styles.textInput} name="description" value={item.description || ''} onChange={(e) => handleChange(e, idx)} />
                      </td>
                      <td className={styles.td_disciple}>
                        <button className={styles.button} onClick={() => handleEdit(item)}>
                          수정
                        </button>
                        <button className={styles.button} onClick={() => showDeleteConfirmBox(() => handleDelete(item.id))}>
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))}
                {/* 입력부 --------------------------------------------- */}
                <tr>
                  <th className={styles.td_disciple}>추가</th>
                  <td className={styles.td_disciple}>
                    <input type="text" className={styles.textInput} name="department" value={newType.department} onChange={(e) => setNewType({ ...newType, department: e.target.value })} />
                  </td>
                  <td className={styles.td_disciple}>
                    <input type="text" className={styles.textInput} name="displayName" value={newType.displayName} onChange={(e) => setNewType({ ...newType, displayName: e.target.value })} />
                  </td>
                  <td className={styles.td_disciple}>
                    <input type="text" className={styles.textInput} name="description" value={newType.description} onChange={(e) => setNewType({ ...newType, description: e.target.value })} />
                  </td>
                  <td className={styles.td_disciple}>
                    <button
                      className={[styles.wideButton, newType.department === '' || newType.displayName === '' ? styles.disabled : ''].join(' ')} //
                      onClick={handleAddType} //
                      disabled={newType.department === '' || newType.displayName === ''}
                    >
                      등록
                    </button>
                  </td>
                </tr>
                {/* 입력부 --------------------------------------------- */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <!--//e: #content --> */}
    </div>
  );
};

export default AdminYCMS;
